import { Box, Typography } from '@mui/material';
import { PageBase } from '../PageBase';
import { theme } from '@/styles/theme';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TableCell } from '@/components/tableCell/TableCell';

export const PrivacyPolicy = () => {
  const { t } = useTranslation('privacyPolicy');
  const navigate = useNavigate();

  return (
    <PageBase title={t('create_password')} onBackClick={() => navigate(-1)} paddingInline={0}>
      <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Box>
          <Typography
            sx={{
              fontSize: '1.8rem',
              fontWeight: 600,
              color: theme.palette.primary.main,
            }}
          >
            {t('privacy_policy')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('how_we_use_and_store')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.0rem',
              fontWeight: 400,
            }}
          >
            {t('last_updated')}
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 600,
            }}
          >
            {t('introduction')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('welcome_message')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 600,
            }}
          >
            {t('hipaa')}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: 3.3 }}>
        <TableCell
          title={t('data_collection_title')}
          description={t('data_collection_description')}
          showLeftIcon={true}
          iconLeftType={'bracket'}
          showRightIcon={true}
          iconRightType={'arrow'}
          onAction={() => navigate('/data-collection')}
        />
        <TableCell
          title={t('data_use_title')}
          description={t('data_use_description')}
          showLeftIcon={true}
          iconLeftType={'circleLocation'}
          showRightIcon={true}
          iconRightType={'arrow'}
          onAction={() => navigate('/data-use')}
        />
        <TableCell
          title={t('data_security_title')}
          description={t('data_security_description')}
          showLeftIcon={true}
          iconLeftType={'circleLocation'}
          showRightIcon={true}
          iconRightType={'arrow'}
          onAction={() => navigate('/data-security')}
        />
      </Box>
    </PageBase>
  );
};
